export const formatPrice = (price, currency = 'ETC') => {
  if (!price) return `0`;
  const num = parseFloat(price);
  // Format to 2 decimal places, remove trailing zeros
  const formatted = num.toFixed(2).replace(/\.?0+$/, '');
  return formatted;
};

export const formatDate = (timestamp) => {
  if (!timestamp) return 'Unknown';
  return new Date(timestamp * 1000).toLocaleDateString();
};

export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}...`;
};

export const capitalizeFirst = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0';
  return num.toLocaleString();
};
